import React, { Component } from 'react';
import cross from '../../../assets/images/close_popup.svg';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { utilityBaseURL } from '../../../Services/config/apiGateway';
import { ADVERTISEMENTSLOT_ENDPOINT, ADVERTISEMENTS_ENDPOINT, DOWNLOAD_ENDPOINT } from '../../../Services/config/apiEndPoints';
import EditAdvertisementData from "./EditAdvertisementDataViaSlot";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/advertisement/AvailableSlots.css';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
// import { store } from '../../../redux/_helpers/store';
// import {successLoader,} from '../../../redux/_actions/loader.action';
import Loader from 'react-loader';
import { AES, enc } from 'crypto-js';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'cookies-js';
toast.configure()
var decodeImage = '';
var editModalCall = false
var hasOpenEdit = false
// var pageDisable = false;
var loaderTime = false;
class AvailableSlots extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advertisementSlot: [],
      advertisementData: [],
      editIndex: '',
      isEditViaSlot: true,
    }
  }
  componentDidMount() {
    ApiCall(
      'GET',
      utilityBaseURL + ADVERTISEMENTSLOT_ENDPOINT,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ' x-cc-trace-id': '1234',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
        }
        else {
          console.log('I am 200!');
          console.log(apiData);
          this.setState({ advertisementSlot: apiData });
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }
  getDate = (dateString) => {
    //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
    let dateParts = dateString.split("/");
    // month is 0-based, that's why we need dataParts[1] - 1
    let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
    let day = date.split(' ')[2];
    let month = date.split(' ')[1];
    let year = date.split(' ')[3];
    return `${day}-${month}-${year}`;
  }
  slotVisit = (slot) => {
    loaderTime = true
    // store.dispatch(successLoader(false));
    ApiCall(
      'GET',
      utilityBaseURL + ADVERTISEMENTS_ENDPOINT + `?aDId=${slot}`,
      {},
      {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ' x-cc-trace-id': '1234',
      },
    ).then((apiData) => {
      if (apiData.flag !== -1) {
        if (apiData.flag === 500) {
          // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
        }
        else {
          console.log('I am 200!');
          this.setState({ advertisementData: apiData[0] });
          let testAccess = Cookies.get('msAL_admin_dev');
          testAccess = JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
          if (apiData.length > 0) {
            console.log("in xml function");
            var xhr = new XMLHttpRequest();
            var URLToImage = utilityBaseURL + DOWNLOAD_ENDPOINT + `?documentPath=${apiData[0].aDImageWebLink}`;
            xhr.open("GET", URLToImage, true);
            // WITH ENCRYPTION
            xhr.setRequestHeader("authorization", 'Bearer' + ` ${testAccess}`);
            // WITHOUT ENCRYPTION
            // xhr.setRequestHeader("authorization", 'Bearer' + ` ${Cookies.get('msAL_admin_dev')}`);
            // Ask for the result as an ArrayBuffer.
            xhr.responseType = "arraybuffer";
            xhr.onload = function (e) {
              // Obtain a blob: URL for the image data.
              var arrayBufferView = new Uint8Array(this.response);
              var blob = new Blob([arrayBufferView], { type: "image/jpg" });
              var urlCreator = window.URL || window.webkitURL;
              var imageUrl = urlCreator.createObjectURL(blob);
              decodeImage = imageUrl;
              loaderTime = false
              // store.dispatch(successLoader(true));
              editModalCall = true
              hasOpenEdit = true
            };
            xhr.send();
          }
        }
      } else {
        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
      }
    });
  }
  onCloseEditModal = () => {
    hasOpenEdit = false;
    editModalCall = false;
    window.location.reload();
  };
  render() {
    return (
      <div class="availableSlotsmodalcss" >
        <MetaDecorator title={TitleDescription.availableSlotsPageTitle} description={TitleDescription.availableSlotsPageDescription} />
        <div class="availableSlotsmodalcssin">
          <Loader
            loaded={!loaderTime}
            lines={10}
            length={10}
            width={10}
            radius={10}
            corners={1}
            rotate={0}
            direction={1}
            color="#000"
            speed={1}
            trail={60}
            shadow={false}
            hwaccel={false}
            className='spinner'
            zIndex={2e9}
            top="50%"
            left="50%"
            scale={1.0}
            loadedClassName="loadedContent"
          />
          <div className='availableSlotcross'>
            <img src={cross} width="21" height="21" onClick={this.props.onClick} class="d-inline-block align-top" alt="" loading="lazy" />
          </div>
          <div class="availableSlotsupperdiv">
            <small class="upedit">
              Available Slots
          </small>
          </div>
          <div>
            <table className="slotHeadingTable">
              <tbody>
                <tr>
                  <td className="slotHeading" id="dates">Dates</td>
                  <td className="slotHeading" id="slotsAvailable">Slots Available *</td>
                  <td className="slotHeading" id="slotDetails">Allocated Slots Detail</td>
                </tr>
              </tbody>
            </table>
            <div className="allSlotData">
              <table className="slotDataTable">
                <tbody>
                  {
                    this.state.advertisementSlot.map((data, index) =>
                      <tr className="bodySlotDetails">
                        <td className="slotData" id="dataDate">{this.getDate(data.adDate)}</td>
                        <td className="slotData" id="dataSlotAvailable">{data.slotAvailable}</td>
                        <td id="dataSlotDetails" >
                          {data.allotedSlotsDetails.map(slot =>
                            <div onClick={() => this.slotVisit(slot)}>
                              <p className="adId">AD{slot + "; "}  {" "}</p>
                            </div>
                          )
                          }</td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
            </div>
            <div className="noteContainer">
              <small className="slotnotesText">* Maximum slots available for each day is 10.</small>
            </div>
          </div>
          {hasOpenEdit === true || editModalCall === true ?
            <EditAdvertisementData onClick={this.onCloseEditModal} decodeUrl={decodeImage} advertisementData={this.state.advertisementData} editIndex={[0]} isEditViaSlot={this.state.isEditViaSlot} /> : null}
        </div>
      </div>
    );
  }
}
export default AvailableSlots;